export default __webpack_public_path__ + "static/media/food.7a9a934e.png";